import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartCount = Array.isArray(cartItems)
    ? cartItems.reduce((sum, item) => sum + (item?.quantity || 0), 0)
    : 0;

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" onClick={toTop} className="brand">
          Ownmarketplace
        </Link>

        <nav className="nav">
          <Link to="/shop" onClick={toTop}>
            Shop
          </Link>
          <Link to="/about" onClick={toTop}>
            About Us
          </Link>{" "}
          <Link to="/contact" onClick={toTop}>
            Contact Us
          </Link>
        </nav>

        <div className="actions">
          <Link
            to="/cartpage"
            onClick={toTop}
            className="action-btn cart"
            aria-label="Cart"
          >
            <FontAwesomeIcon icon={faBagShopping} />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
